import {
    skinVars,
    BoxedRow,
    RadioGroup,
    Text3,
    ButtonPrimary,
    Divider,
    IconInvoiceEuroRegular,
    EmptyState,
    useWindowSize,
    BoxedRowList,
    ButtonFixedFooterLayout,
    Spinner,
} from '@telefonica/mistica';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import GenericHeader from '../../../../../components/GenericHeader';
import { useBillsContext } from '../../../../../context/bills-context/BillsContext';
import { ClaimsTypeTypes } from '../../../../../models/Bills.interfaces';
import HeaderComponent from '../../../../../components/HeaderComponent';
import { getClaimProcedures, getClaimReclaimable } from '../../../../../services/BillService';

const ClaimType = () => {
    const { claimType, setClaimsType, resetClaimValues, bill } = useBillsContext();
    const navigate = useNavigate();
    const size = useWindowSize();
    const [isClaimAllowed, setIsClaimAllowed] = useState(false);
    const [isAlreadyClaimed, setIsAlreadyClaimed] = useState(false);
    const [firstLoading, setfirstLoading] = useState(true);

    const checkIfClaimIsAllowed = async () => {
        try {
            const response = await getClaimProcedures(bill.id);

            setIsClaimAllowed(response.data);

            const res = await getClaimReclaimable(bill.id);
            if (response.data) {
                setIsAlreadyClaimed(res.data);
                resetClaimValues();
            }
            setfirstLoading(false);
        } catch (error) {
            setfirstLoading(false);
            console.error(error);
        }
    };

    useEffect(() => {
        checkIfClaimIsAllowed();
    }, []);

    const navigationBackHandler = () => navigate('/claims/management-invoice');

    const saveHandler = () => navigate('/claims/claims-selection');

    if (firstLoading) {
        return (
            <div className='c-spinner'>
                <Spinner size={24} />
                <span style={{ background: 'white' }} className='c-spinner-overlay'></span>
            </div>
        );
    }

    return (
        <section className='selectClaimType'>
            {(!isClaimAllowed || !isAlreadyClaimed) && (
                <GenericHeader
                    title={t('openClaim')}
                    navigationBarOnBack={navigationBackHandler}
                    onReturn={navigationBackHandler}
                />
            )}
            {isClaimAllowed && isAlreadyClaimed ? (
                <React.Fragment>
                    <HeaderComponent
                        title={t('openClaim')}
                        navigationBarOnBack={navigationBackHandler}
                        breadcrumbs={[
                            { title: t('invoice'), url: '/bills' },
                            { title: t('breadcrumbsTitleBillDetail'), url: `/bills/bill-detail?id=${bill.id}` },
                            {
                                title: t('billManagement'),
                                url: '/claims/management-invoice',
                            },
                        ]}
                    />
                    {size?.width >= 1024 ? (
                        <div className='selectClaimType__content'>
                            <div className='selectClaimType__title'>
                                <Text3 regular>{t('selectClaimReason')}</Text3>
                            </div>

                            <div className='selectClaimType__radioGroup'>
                                <RadioGroup
                                    name={'claimManagement'}
                                    value={claimType}
                                    onChange={(value) => setClaimsType(value as ClaimsTypeTypes)}
                                >
                                    <BoxedRowList>
                                        <BoxedRow title={t('tarrifRate')} radioValue='quota' />
                                        <BoxedRow title={t('extraconsumption')} radioValue='additional' />
                                    </BoxedRowList>
                                </RadioGroup>
                            </div>
                            <div className='selectClaimType__bottom'>
                                <ButtonPrimary onPress={saveHandler} disabled={claimType === ''}>
                                    {t('continue')}
                                </ButtonPrimary>
                            </div>
                        </div>
                    ) : (
                        <ButtonFixedFooterLayout
                            button={
                                <ButtonPrimary onPress={saveHandler} disabled={claimType === ''}>
                                    {t('continue')}
                                </ButtonPrimary>
                            }
                        >
                            <div className='selectClaimType__content'>
                                <div className='selectClaimType__title'>
                                    <Text3 regular>{t('selectClaimReason')}</Text3>
                                </div>

                                <div className='selectClaimType__radioGroup'>
                                    <RadioGroup
                                        name={'claimManagement'}
                                        value={claimType}
                                        onChange={(value) => setClaimsType(value as ClaimsTypeTypes)}
                                    >
                                        <BoxedRowList>
                                            <BoxedRow title={t('tarrifRate')} radioValue='quota' />
                                            <BoxedRow title={t('extraconsumption')} radioValue='additional' />
                                        </BoxedRowList>
                                    </RadioGroup>
                                </div>
                            </div>
                        </ButtonFixedFooterLayout>
                    )}
                </React.Fragment>
            ) : (
                <div className='selectClaimType__not-allowed'>
                    <div className='selectClaimType__divider'>
                        <Divider />
                    </div>

                    <div className='selectClaimType__empty'>
                        <EmptyState
                            asset={<IconInvoiceEuroRegular color={skinVars.colors.brand} size={64} />}
                            title={t('ClaimNotAvailableTitle')}
                            description={
                                !isAlreadyClaimed ? t('ClaimNotAvailableDescription') : t('ClaimNAvailableDescription')
                            }
                        ></EmptyState>
                    </div>
                </div>
            )}
        </section>
    );
};

export default ClaimType;
